import {
  FaReact,
  FaJs,
  FaPython,
  FaHtml5,
  FaCss3Alt,
  FaGithub,
  FaDocker,
  FaNodeJs,
} from "react-icons/fa";
import {
  SiTailwindcss,
  SiPostgresql,
  SiMongodb,
  SiApachenetbeanside,
} from "react-icons/si";
import { FaCode } from "react-icons/fa";
import { MdApi } from "react-icons/md";

const icons = [
  { icon: <FaReact />, color: "text-blue-400" },
  { icon: <FaJs />, color: "text-yellow-400" },
  { icon: <FaPython />, color: "text-green-400" },
  { icon: <FaCode />, color: "text-blue-300" },
  { icon: <SiPostgresql />, color: "text-indigo-300" },
  { icon: <SiMongodb />, color: "text-green-300" },
  { icon: <FaDocker />, color: "text-cyan-300" },
  { icon: <FaGithub />, color: "text-white" },
  { icon: <FaCss3Alt />, color: "text-blue-200" },
  { icon: <FaHtml5 />, color: "text-orange-300" },
  { icon: <SiTailwindcss />, color: "text-sky-300" },
  { icon: <FaNodeJs />, color: "text-green-400" },
  { icon: <MdApi />, color: "text-purple-300" },
  { icon: <SiApachenetbeanside />, color: "text-pink-300" }, // general tech symbol
];

export default function FloatingTechIcons() {
  return (
    <div className="absolute inset-5 z-0 pointer-events-none flex flex-wrap justify-center gap-16 p-20">
      {icons.map((item, index) => (
        <div
          key={index}
          className={`text-6xl opacity-25 animate-floatDrift ${item.color}`}
          style={{
            animationDelay: `${index * 0.5}s`,
            }}
        >
          {item.icon}
        </div>
      ))}
    </div>
  );
}
